export default {
    'widgets.notifications.fusion-swap-view.status.pending': 'En attente',
    'widgets.notifications.fusion-swap-view.status.filled': 'Terminé',
    'widgets.notifications.fusion-swap-view.status.false-predicate': 'Rempli',
    'widgets.notifications.fusion-swap-view.status.not-enough-balance-or-allowance': 'Rempli',
    'widgets.notifications.fusion-swap-view.status.partially-filled': 'Rempli',
    'widgets.notifications.fusion-swap-view.status.wrong-permit': 'Rempli',
    'widgets.notifications.fusion-swap-view.status.invalid-signature': 'Rempli',
    'widgets.notifications.fusion-swap-view.status.expired': 'Expiré',
    'widgets.notifications.fusion-swap-view.status.cancelled': 'Annulé',
    'widgets.notifications.fusion-swap-view.control.cancel': 'Annuler',
};
//# sourceMappingURL=fr.js.map